import { isEmpty } from './isEmpty';

/**
 * @memberof module:util
 * @function
 * @name getActiveShipmentMode
 * @description Get which shipment type is selected.
 *
 * @param {Object} getState - whole Redux store state
 * @returns {Object}
 *
 * @example
 * console.log(getActiveShipmentMode(...));
 *
 * //output
 * { fclActive:false, lclActive: true, airActve:false } // it means LCL shipment type is selected
 */

export const getActiveShipmentMode = (getState) => {
  const seaFCLJSON = getState().route.seaFCLJSON;
  const seaLCLJSON = getState().route.seaLCLJSON;
  const airJSON = getState().route.airJSON;

  let fclActive =
    (!isEmpty(seaFCLJSON) &&
      seaFCLJSON.rates &&
      Array.isArray(seaFCLJSON.rates.fcl) &&
      seaFCLJSON.rates.fcl.length !== 0 &&
      true) ||
    false;

  let lclActive =
    (!isEmpty(seaLCLJSON) &&
      seaLCLJSON.rates &&
      Array.isArray(seaLCLJSON.rates.lcl) &&
      seaLCLJSON.rates.lcl.length !== 0 &&
      true) ||
    false;

  let airActve =
    (!isEmpty(airJSON) &&
      airJSON.rates &&
      Array.isArray(airJSON.rates.air) &&
      airJSON.rates.air.length !== 0 &&
      true) ||
    false;

  return { fclActive, lclActive, airActve };
};
